(function () {
  "use strict";

  function initSection(root) {
    if (!root || root.dataset.jtInit === "1") return;
    root.dataset.jtInit = "1";

    /* ---------- FAQ accordion — multi open ---------- */
    root.querySelectorAll(".jt-faq-item").forEach(function (item) {
      var btn = item.querySelector(".jt-faq-q");
      var tog = item.querySelector(".jt-faq-toggle");
      if (!btn || !tog) return;
      btn.setAttribute("aria-expanded", "false");
      btn.addEventListener("click", function () {
        var isOpen = item.classList.contains("jt-open");
        if (isOpen) {
          item.classList.remove("jt-open");
          tog.textContent = "+";
          btn.setAttribute("aria-expanded", "false");
        } else {
          item.classList.add("jt-open");
          tog.textContent = "−";
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });

    /* ---------- Scroll reveal (IntersectionObserver) ---------- */
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add("jt-in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      root.querySelectorAll(".jt-reveal").forEach(function (el) {
        io.observe(el);
      });
    } else {
      root.querySelectorAll(".jt-reveal").forEach(function (el) {
        el.classList.add("jt-in");
      });
    }

    /* ---------- Reviews carousel ---------- */
    function initCarousel() {
      var track    = root.querySelector(".jt-reviews-track");
      var viewport = root.querySelector(".jt-reviews-viewport");
      var prev     = root.querySelector(".jt-review-arrow.jt-prev");
      var next     = root.querySelector(".jt-review-arrow.jt-next");
      var dotsWrap = root.querySelector(".jt-review-dots");
      if (!track || !viewport || !dotsWrap) return;

      var cards   = track.querySelectorAll(".jt-review-card");
      var total   = cards.length;
      var perView = 3;
      var index   = 0;
      var gap     = 24;

      function compute() {
        perView = window.innerWidth <= 768 ? 1 : 3;
        var vw    = viewport.clientWidth;
        var cardW = perView === 1 ? vw : (vw - gap * (perView - 1)) / perView;
        cards.forEach(function (c) {
          c.style.flex        = "0 0 " + cardW + "px";
          c.style.marginRight = perView === 1 ? "0px" : gap + "px";
        });
        var maxIndex = Math.max(0, total - perView);
        if (index > maxIndex) index = maxIndex;
        renderDots(maxIndex);
        apply();
      }

      function renderDots(maxIndex) {
        dotsWrap.innerHTML = "";
        for (var i = 0; i <= maxIndex; i++) {
          var b = document.createElement("button");
          b.className = "jt-review-dot" + (i === index ? " jt-active" : "");
          b.setAttribute("aria-label", "Slide " + (i + 1));
          (function (n) {
            b.addEventListener("click", function () { index = n; apply(); });
          })(i);
          dotsWrap.appendChild(b);
        }
      }

      function apply() {
        var vw    = viewport.clientWidth;
        var cardW = perView === 1 ? vw : (vw - gap * (perView - 1)) / perView;
        var step  = cardW + (perView === 1 ? 0 : gap);
        track.style.transform = "translateX(" + (-index * step) + "px)";
        var maxIndex = Math.max(0, total - perView);
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex;
        dotsWrap.querySelectorAll(".jt-review-dot").forEach(function (d, i) {
          d.classList.toggle("jt-active", i === index);
        });
      }

      if (prev) {
        prev.addEventListener("click", function () {
          if (index > 0) { index--; apply(); }
        });
      }
      if (next) {
        next.addEventListener("click", function () {
          var m = Math.max(0, total - perView);
          if (index < m) { index++; apply(); }
        });
      }

      var startX = 0, deltaX = 0, touching = false;
      viewport.addEventListener("touchstart", function (e) {
        touching = true; startX = e.touches[0].clientX; deltaX = 0;
      }, { passive: true });
      viewport.addEventListener("touchmove", function (e) {
        if (touching) deltaX = e.touches[0].clientX - startX;
      }, { passive: true });
      viewport.addEventListener("touchend", function () {
        if (!touching) return;
        touching = false;
        var m = Math.max(0, total - perView);
        if      (deltaX < -40 && index < m) { index++; apply(); }
        else if (deltaX >  40 && index > 0) { index--; apply(); }
      });

      window.addEventListener("resize", compute);
      compute();
    }

    initCarousel();
  }

  function initAll() {
    document.querySelectorAll(".japan-trips").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (e) {
      var root = e.target.querySelector(".japan-trips");
      if (root) initSection(root);
    });
  }
})();
